//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
    /**
     * Date picker selector used as a search filter control. Wraps the new unison date picker.
     *
     * Values for this search filter will have the format:
     * { alias: 'last7Days', value: 'last7Days }
     *
     * Possible values are: today, last7Days, last30Days, last3Months, allTime. These possible aliases can be found in cuDateLiteService.ALIASES
     * OR it can be formatted with a custom date range { alias: 'custom': startDate: new Date('1/1/17'), endDate: new Date('1/4/17')}.
     * Note: startDate and endDate are required when using the custom alias, but should be omitted when using any other alias.
     */
  angular.module('curalate').component('searchFilterDatePicker', {
    bindings: {
      dateRangeAliases: '<',
      minDate: '<',
      minDateMessage: '<',
      retentionDays: '<',
      datePickerPositioningStrategy: '<?',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    template: require('@legacy-components/filters/search-filter-date-picker.html'),
    controller: ['$scope', 'cuDateLiteService',
      function($scope, DLS) {
        const self = this;

        const formatDate = (date) => {
          return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        };

        const getCustomDateAlias = (datePickerObj) => {
          const startDate = formatDate(datePickerObj.startDate);
          const endDate = formatDate(datePickerObj.endDate);

          return `${startDate} - ${endDate}`;
        };

        const extendDateObj = function(datePickerObj) {
          if (datePickerObj.alias === DLS.ALIASES.custom.name) {
                        // for a custom date range, show the actual date range instead of just "Custom".
            const customAlias = getCustomDateAlias(datePickerObj);
            self.searchFilter.registerFilterOptionAlias(DLS.ALIASES.custom.name, customAlias);
          }
          return _(datePickerObj).extend({
            value: datePickerObj.alias || '',
            aliasKey: datePickerObj.alias || '',
          });
        };

        const initialDateObject = { alias: DLS.ALIASES.allTime.name };
        $scope.model = {};

        const setRangeAge = (datePickerObj) => {
          if (datePickerObj.alias === DLS.ALIASES.custom.name) {
            const today = moment();
            const start = moment(datePickerObj.startDate);
            self.rangeAge = today.diff(start, 'days') + 1;
          } else {
            self.rangeAge = 0;
          }
        };

        $scope.model.dateChange = function(datePickerObj) {
          if (datePickerObj.alias === DLS.ALIASES.allTime.name) {
            self.searchFilter.setValues([]);
          } else {
            self.searchFilter.setValue(extendDateObj(datePickerObj));
          }

          setRangeAge(datePickerObj);
        };

        this.$onInit = function() {
          const currentSearchFilterValue = _(self.searchFilter.getValue()).safeGet('0');
          if (!currentSearchFilterValue) {
            $scope.model.value = initialDateObject;
            $scope.model.dateChange(initialDateObject);
          }

          _(DLS.ALIASES).each((dt) => {
            self.searchFilter.registerFilterOptionAlias(dt.name, dt.display);
          });

          $scope.model.lockedKey = self.searchFilter.isKeyLocked();

          self.searchFilter.getFilterValueStream().subscribe((newState) => {
            if (newState && newState[0]) {
              $scope.model.value = newState[0];
              setRangeAge($scope.model.value);
            } else if (newState && newState.length === 0) {
              $scope.model.value = initialDateObject;
            }
          });
        };
      },
    ],
  });
})();
